import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HotelsService } from '@app/hotels/hotels/hotels.service';
import { ApiQuery } from '@app/core/http/api-query';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { Logger } from '@app/core';
import { Hotel } from '@app/hotels/hotels/hotel.model';
import { VenuesService } from '@app/settings/venues/venues.service';
import { Venue } from '@app/settings/venues/venue.model';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';

const log = new Logger('MapModalComponent');

@Component({
  selector: 'app-map-modal',
  templateUrl: './map-modal.component.html',
  styleUrls: ['./map-modal.component.scss'],
})
export class MapModalComponent implements OnInit {
  @Input() hotelsIds: Array<number> = [];
  @Input() venuesIds: Array<number> = [];
  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
  @ViewChildren(MapMarker) markers!: QueryList<MapMarker>;
  selectedPlace: any;

  hotels: Array<Hotel>;
  venues: Array<Venue>;
  previous: any;
  mapOptions: google.maps.MapOptions = {
    scrollwheel: false,
    fullscreenControl: true,
    zoomControl: true,
  };
  mapCenter = { lat: 42.0, lng: 21.0 };
  mapDataReady = false;
  @ViewChild(GoogleMap, { static: false }) map: GoogleMap;


  constructor(
    public modal: NgbActiveModal,
    private hotelsService: HotelsService,
    private venuesService: VenuesService
  ) {}

  async ngOnInit() {
    await this.getHotels();
    await this.getVenues();
    this.mapDataReady = true;
  }

  number(number: any): number {
    return Number(number);
  }

  getHotels(): Promise<void> {
    return new Promise((resolve) => {
      if (this.hotelsIds.length > 0) {
        const query = new ApiQuery().setLimit(99999).addFilter('id', this.hotelsIds.toString());
        this.hotelsService.index(query).subscribe((hotels: PaginatedResponse) => {
          this.hotels = hotels.data;
          this.fitBoundsToMarkers('hotels').then(() => {resolve(); });
          resolve();
        });
      } else {
        resolve();
      }
    });
  }

  getVenues(): Promise<void> {
    return new Promise((resolve) => {
      if (this.venuesIds.length > 0) {
        const query = new ApiQuery().setLimit(99999).addFilter('id', this.venuesIds.toString());
        this.venuesService.index(query).subscribe((venues: PaginatedResponse) => {
          this.venues = venues.data;
          this.fitBoundsToMarkers('venues').then(() => {resolve(); });
        });
      } else {
        resolve();
      }
    });
  }

  async fitBoundsToMarkers(type: string) {
    await google.maps.importLibrary('maps');
    const bounds = new google.maps.LatLngBounds();

    for (const item of this[type]) {
      bounds.extend(new google.maps.LatLng(Number(item.lat), Number(item.long)));
    }

    setTimeout(() => {
      this.map?.fitBounds(bounds);
    });
  }

  clickedMarker( selectedPlace: Hotel | Venue, index: number) {
    this.selectedPlace = selectedPlace;

    setTimeout(() => {
      const marker = this.markers.get(index);
      if (marker) {
        this.infoWindow.open(marker);
      } else {
        console.warn('Marker not found for index:', index);
      }
    });
  }
}
